import { SMART_PREFILL_ERROR_CODES } from "./constants";

export const SMART_PREFILL_STRINGS = {
    buttonLabel: "Smart Prefill",
    modalTitle: "Smart Prefill Event Type",
    apiKeyLabel: "Gemini API key (optional override)",
    apiKeyPlaceholder: "Leave blank to use the default key",
    apiKeyHelper: "Stored in this browser only if you choose to remember it.",
    rememberKeyLabel: "Remember override key on this device",
    promptLabel: "Describe the event type",
    promptPlaceholder: "Example: A weekend golf trip with friends and friendly bets.",
    helperText: "Include a short description and any example questions you want.",
    cancelButton: "Cancel",
    generateButton: "Generate",
    generatingButton: "Generating...",
    testButton: "Test Key",
    testingButton: "Testing...",
    testResultLabel: "Key Test Result",
    testModelsLabel: "Models",
    testMoreModelsSuffix: "more",
    generatedQuestionsLabel: "Generated questions",
    errorMissingPrompt: "Please enter a description.",
    errorMissingApiKey: "Gemini is not configured. Add an API key and try again.",
    errorModelNotFound: "Gemini model not found. Check API access or try a different key.",
    errorModelListFailed: "Key test failed. Check API access or restrictions.",
    errorInvalidResponse: "Smart Prefill could not parse a valid response.",
    errorGenerationFailed: "Smart Prefill failed to generate results.",
    warningQuestionsFailed: "Event type saved, but some questions failed to save. Open Questions to finish."
};

export const getGeneratedQuestionsLabel = (count) => `${SMART_PREFILL_STRINGS.generatedQuestionsLabel}: ${count}`;
export const formatKeyTestSuccessMessage = (apiVersion, count) =>
    `Key is valid (${apiVersion}). Models found: ${count}.`;
export const formatKeyTestFailureMessage = (status) =>
    `Key test failed (status: ${status}).`;
export const formatMoreModelsLabel = (count) =>
    `+${count} ${SMART_PREFILL_STRINGS.testMoreModelsSuffix}`;

const SMART_PREFILL_ERROR_MESSAGES = {
    [SMART_PREFILL_ERROR_CODES.emptyPrompt]: SMART_PREFILL_STRINGS.errorMissingPrompt,
    [SMART_PREFILL_ERROR_CODES.missingApiKey]: SMART_PREFILL_STRINGS.errorMissingApiKey,
    [SMART_PREFILL_ERROR_CODES.modelNotFound]: SMART_PREFILL_STRINGS.errorModelNotFound,
    [SMART_PREFILL_ERROR_CODES.modelListFailed]: SMART_PREFILL_STRINGS.errorModelListFailed,
    [SMART_PREFILL_ERROR_CODES.invalidResponse]: SMART_PREFILL_STRINGS.errorInvalidResponse,
    [SMART_PREFILL_ERROR_CODES.generationFailed]: SMART_PREFILL_STRINGS.errorGenerationFailed
};

export const getSmartPrefillErrorMessage = (error) => {
    const code = error?.code;
    return SMART_PREFILL_ERROR_MESSAGES[code] || SMART_PREFILL_STRINGS.errorGenerationFailed;
};

export const getSmartPrefillTestErrorMessage = (error) => {
    if (error?.status) {
        return formatKeyTestFailureMessage(error.status);
    }
    const code = error?.code;
    return SMART_PREFILL_ERROR_MESSAGES[code] || SMART_PREFILL_STRINGS.errorModelListFailed;
};

export const DYNAMIC_EVENT_TYPE_STRINGS = {
    statusActive: "Active",
    statusInactive: "Disabled",
    enableButton: "Enable",
    disableButton: "Disable",
    statusLabel: "Status",
    statusHelp: "Disabled event types will not appear in the app.",
    activeLabel: "Active",
    statusUpdateError: "Failed to update event type status",
    webImageLoading: "Searching the web for a placeholder image...",
    webImageError: "Could not find a usable image. Upload one manually if needed."
};
